module.exports = __webpack_public_path__ + "static/media/wedding-websites@2x.bde6b057.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/wedding-websites@2x.png
// module id = 729
// module chunks = 53